export default function getAPITokenFromLocalStorage(asAxiosOptions = true) {
  const token = localStorage.getItem('apiToken')
  if (asAxiosOptions) {
    return {
      headers: { Authorization: `Bearer ${token}` },
    }
  }
  return token
}
